import { RootState } from "src/store";

export const printerQueueSelector = (state:RootState) => state.printer.queues;